<template>
  <div id="app">
    <b-container fluid>
    <div v-if="loggedin">
      <Navbar @signout="signout" />
      <router-view/>
    </div>
    <div v-else>
      <div class="login-box">
        <div class="login-logo">
          <span class="logo-strong">Audit</span>Assistant
        </div>
        <div class="login-box-body">
          <div class="login-box-msg">
            <h4 class="login-header">Login with your account</h4>
            <b-form style="margin-top: 30px" @submit.prevent="onSubmit">
              <b-form-input :state="login_input_state" v-model="email" placeholder="Username" />
              <br />
              <b-form-group invalid-feedback="Username and/or password incorrect.">
                <b-form-input :state="login_input_state" type="password" v-model="password" placeholder="Password" />
              </b-form-group>
              <b-btn type="submit">Login</b-btn>
              <b-btn variant="link" class="float-right" disabled>Register</b-btn>
            </b-form>
          </div>
        </div>
      </div>
    </div>
    </b-container>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Navbar from './components/Navbar.vue'
import QuestionnaireGroups from './components/QuestionnaireGroups.vue'

export default {
  name: 'app',
  components: {
    QuestionnaireGroups,
    Navbar
  },
  data: function() {
    return {
      email: '',
      password: '',
      loggedin: process.env.NODE_ENV === 'developments',
      login_input_state: null
    }
  },
  mounted() {
    if(localStorage.login == "yes") {
      this.loggedin = true;
    }
  },
  methods: {
    onSubmit() {
      if (this.email == 'gab' && this.password == 'turt1l3!') {
        this.loggedin = true;
        localStorage.login = "yes";
        this.password = '';
      }
      else {
        this.login_input_state = false;
        this.password = '';
      }
    },
    signout() {
      localStorage.login = false;
      this.loggedin = false;
    }
  }
}
</script>

<style scoped>
.login-box {
  width: 500px;
  margin: 7% auto;
}
.login-logo {
  font-size: 35px;
  text-align: center;
  margin-bottom: 25px;
  font-weight: 300;
}
.login-box-body {
  background: #f0f0f0;
  padding: 20px;
  border-top: 0;
  color: #666;
}
.login-box-msg {
  margin: 0;
  padding: 0 20px 20px 20px;
}
.login-header {
  text-align: center;
}
.btn {
  margin-top: 20px;
}
.logo-strong {
  font-weight: 800;
}
</style>